<div mat-dialog-container
     class="detailed-association-dialog box-layout">

  <button class="back-button"
          (click)="onNoClick()">
    <i class="far fa-arrow-circle-left"></i>
    <div class="back-text"
         translate="MODAL.BACK"></div>
  </button>

  <div mat-dialog-content>


    <div class="header">
      <h1>{{ selectedDepartment.code }} &#8901;
        {{ selectedDepartment.description }}</h1>
    </div>


    <div class="structure-association-headers">
      <span translate="HEADER.SUBLEVELS"></span>
      <span translate="HEADER.ACTIVE"></span>
    </div>

    <div class="structure-association-container">
      <div class="association-level1-node"
           *ngFor="let level1Node of level1Tree">
        <div class="association-level-row"
             *ngIf="!isLevel2">
          <div class="association-level-col">
            <i class="far fa-chevron-right"
               *ngIf="expandedLevel1Ids.indexOf(level1Node.data.level.id) === -1"
               (click)="expandNode(level1Node)"></i>
            <i class="far fa-chevron-down"
               *ngIf="expandedLevel1Ids.indexOf(level1Node.data.level.id) !== -1"
               (click)="collapseNode(level1Node)"></i>
            <span style="margin-left: 5px">{{ level1Node.data.level.code }} &#8901;
              {{ level1Node.data.level.description }}</span>
          </div>
          <div class="association-switch-col"
               *ngIf="!isLevel2">
            <label class="switch">
              <input type="checkbox"
                     (change)="onAssociationChange($event, level1Node)"
                     [checked]="level1Node.data?.isAssociated" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>

        <!--if structureDepth === Level2, only display the level1 with children-->
        <div class="association-level-row"
             *ngIf="isLevel2 && level1Node.children.length > 0">
          <div class="association-level-col highlight">
            <div>
              <i class="far fa-chevron-right"
                 *ngIf="expandedLevel1Ids.indexOf(level1Node.data.level.id) === -1"
                 (click)="expandNode(level1Node)"></i>
              <i class="far fa-chevron-down"
                 *ngIf="expandedLevel1Ids.indexOf(level1Node.data.level.id) !== -1"
                 (click)="collapseNode(level1Node)"></i>
              <span style="margin-left: 5px; font-weight: 500">{{ level1Node.data.level.code }} &#8901;
                {{ level1Node.data.level.description }}</span>
            </div>
            <div class="association-switch-col">
              <label class="switch">
                <input type="checkbox"
                       (change)="onAssociationChange($event, level1Node)"
                       [checked]="level1Node.data?.isAssociated" />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <ng-container *ngIf="expandedLevel1Ids.indexOf(level1Node.data.level.id) !== -1">
            <div class="association-level2-node"
                 *ngFor="let level2Node of level1Node.children; let i = index">
              <div class="association-level2-row">
                <div class="association-level2-col">
                  <span>{{ level2Node.data.level.code }} &#8901;
                    {{ level2Node.data.level.description }}</span>
                </div>
                <div class="association-switch-col">
                  <label class="switch">
                    <input type="checkbox"
                           (change)="onAssociationChange($event, level2Node)"
                           [checked]="level2Node.data?.isAssociated" />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
